export default __webpack_public_path__ + "static/media/ic_product_uniqa-vital.a3539783.svg";